import { takeLatest, put, select } from 'redux-saga/effects';
import { LOCALIZATION_SELECT, STATIC_VALUES_GET } from '../actions/types';
import { saveLang } from '../../utils';
import { setValidationLocale } from '../../validations';
import { userPatch } from './user';

function* setLanguage({ payload: { lang } }) {
  yield setValidationLocale(lang);
  yield saveLang(lang);

  try {
    const userId = yield select((s) => s.app.user.id);
    yield userPatch({ payload: { id: userId, preferredLanguage: lang } });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Error patch language:', e);
  }

  // refresh static values already fetched
  const statics = yield select((s) => s.statics);
  const staticsKeys = Object.keys(statics).filter((k) => !!statics[k].length);

  for (let i = 0; i < staticsKeys.length; i += 1) {
    yield put({
      type: STATIC_VALUES_GET._REQUEST,
      payload: { valueName: staticsKeys[i], forced: true },
    });
  }
}

function* watchSetLanguage() {
  yield takeLatest(LOCALIZATION_SELECT, setLanguage);
}
export default [watchSetLanguage];
